/**
 * React Query hooks for the site health checklist (AB#418 / AB#1034).
 */

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { siteHealthApi, type SiteHealthFix } from '../api/siteHealth';
import { siteKeys } from './useSites';

export const siteHealthKeys = {
  detail: (siteSlug: string) => ['sites', siteSlug, 'health'] as const,
};

export function useSiteHealth(siteSlug: string) {
  return useQuery({
    queryKey: siteHealthKeys.detail(siteSlug),
    queryFn: () => siteHealthApi.get(siteSlug),
    enabled: !!siteSlug,
  });
}

/** Applies a one-click fix; the response IS the refreshed health payload. */
export function useSiteHealthFix(siteSlug: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (fix: SiteHealthFix) => siteHealthApi.fix(siteSlug, fix),
    onSuccess: (res) => {
      queryClient.setQueryData(siteHealthKeys.detail(siteSlug), res);
      queryClient.invalidateQueries({ queryKey: siteKeys.settings(siteSlug) });
      queryClient.invalidateQueries({ queryKey: siteKeys.deployState(siteSlug) });
    },
  });
}
